import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EmptyArrowIcon extends BaseIcon {
  getChildren = () => [
    <g fill="none" stroke="#c6c9cf" strokeLinecap="round" strokeWidth="2">
      <path d="M4.507 12.392c169.2 35.389 53.136 170.552 346.758 160.155" strokeMiterlimit="10"/>
      <path d="M22.05771 5.04202L3.46375 11.89895l14.19746 13.82697" strokeLinejoin="round"/>
    </g>
  ]
  getViewBox = () => '0 0 352.3 174.09'
}
